
import axios from "axios";
import { Component, Vue, Prop } from "vue-property-decorator";
import { MstCouponVO } from "../coupon/vo/coupon.vo";
import { RelOrderProductVO } from "./vo/order.vo";

@Component
export default class MyProductCoupons extends Vue {
  @Prop()
  orderCd;

  selectCouponKey = false;

  products = [] as Array<RelOrderProductVO>;

  onProductCouponChanged(product: RelOrderProductVO) {
    const currentProductCoupon = this.getCouponByMemberCouponSeq(product);
    this.$set(product, "couponCd", currentProductCoupon.couponCd || null);
    this.$set(product, "couponDiscountPrice", currentProductCoupon.actualDiscountAmount || 0);

    this.selectCouponKey = !this.selectCouponKey;
  }

  // 회원 쿠폰 seq 로 coupon 객체 취득
  getCouponByMemberCouponSeq(product: RelOrderProductVO): MstCouponVO {
    for (const i in product.availableCoupons) {
      const coupon = product.availableCoupons[i];
      if (coupon.memberCouponSeq == product.memberCouponSeq) {
        console.log(product.memberCouponSeq);
        return coupon;
      }
    }
    return {} as MstCouponVO;
  }

  // 사용 가능 상품 쿠폰
  getAvailableCoupons(product: RelOrderProductVO): Array<MstCouponVO> {
    return product.availableCoupons.filter((coupon) => {
      // 현재 쿠폰이면 true
      if (product.memberCouponSeq == coupon.memberCouponSeq) {
        return true;
      }
      // 다른 상품에서 쿠폰을 쓰고 있으면 false
      for (const i in this.products) {
        const product2 = this.products[i];
        if (product2.memberCouponSeq == coupon.memberCouponSeq) {
          return false;
        }
      }
      return true;
    });
  }

  applyCoupons() {
    axios.put("/order/products/coupon", this.products).then(() => {
      alert(this.$t("common.a0007")); // 적용되었습니다.
      this.$router.push({ name: "OrderPayment", params: { orderCd: this.orderCd, refreshProducts: "1" } });
    });
  }

  created() {
    axios.get(`/order/products/${this.orderCd}/coupons`).then((r) => {
      this.products = r.data;
    });
  }
}
